import { useParams } from 'react-router-dom'
import { useCMSNewsItem } from '../../hooks/use-cms-news'
import { useTranslation } from 'react-i18next'
import { DeferredText } from '@carsys/ui'

export const NewsItemBreadCrumb = () => {
  const { t } = useTranslation()
  const { newsItemID } = useParams<{ newsItemID: string }>()
  const queryData = useCMSNewsItem(newsItemID)

  return <DeferredText data={queryData}>{queryData?.data?.Title || t('cms-news.generic_title')}</DeferredText>
}

export default NewsItemBreadCrumb
